// Care Connect module
import { configureStore } from '@reduxjs/toolkit';
import appointmentReducer from './slices/appointments.slice';
import authReducer from './slices/auth.slice';
import careConnectReducer from './slices/careConnect.slice';
import carePlanReducer from './slices/carePlan.slice';
import practitionerReducer from './slices/practitioner.slice';
import appointmentSettingsReducer from './slices/settings.slice';
import quotaReducer from './slices/quota.slice';
// Ambient AI module
import encounterReducer from '../modules/ambient_solo/store/slices/encounter';
import onboardingReducer from '../modules/ambient_solo/store/slices/onboarding';
import paymentsReducer from '../modules/ambient_solo/store/slices/payments';
import settingsReducer from '../modules/ambient_solo/store/slices/settings';
import summaryReducer from '../modules/ambient_solo/store/slices/summary';
import templateReducer from '../modules/ambient_solo/store/slices/templateSlice';
import audioReducer from '../modules/ambient_solo/store/slices/audio';
import memoryReducer from '../modules/ambient_solo/store/slices/memory';

// EHR module
import ehrReducer from '../modules/EHR/store/slices/ehr';

// Super Admin Module
import conditionReducer from '../../src/modules/SuperAdmin/store/slices/condition.slice';
import formConditionsReducer from '../../src/modules/SuperAdmin/store/slices/formconditions.slice';
import organizationReducer from '../../src/modules/SuperAdmin/store/slices/organization.slice';
import promptReducer from '../../src/modules/SuperAdmin/store/slices/prompts.slice';
import specialtyReducer from '../../src/modules/SuperAdmin/store/slices/specialty.slice';
import doctorsReducer from '../modules/SuperAdmin/store/slices/practitioners.slice';
import preBuiltTemplatesReducer from '../modules/SuperAdmin/store/slices/prebuilttemplates.slice';
import promptsReducer from '../modules/SuperAdmin/store/slices/promptoverrides.slice';
import templateOverridesReducer from '../modules/SuperAdmin/store/slices/templateoverrides.slice';
import humanScribeReducer from '../modules/SuperAdmin/store/slices/humanscribe.slice';
import ehrCredentialsReducer from '../modules/SuperAdmin/store/slices/ehrcredentials.slice';
import orgSettingReducer from '../modules/SuperAdmin/store/slices/organizationsetting.slice';
import questionnaireReducer from '../modules/SuperAdmin/store/slices/questionnaire.slice';
import knowledgebaseReducer from '../modules/SuperAdmin/store/slices/knowledgebase.slice';
import agentsReducer from '../modules/SuperAdmin/store/slices/agents.slice';
import serviceRequestReducer from '../modules/SuperAdmin/store/slices/service_request.slice';
//Template exchange module
import templatesReducer from '../../src/modules/TemplatesExchange/store/slices/templatesexchange.slice';
import autotemplateReducer from '../modules/AutoTemplate/store/slices/autotemplate.slice';
import legalConfirmationReducer from './slices/legalConfirmation.slice';
import userManagementReducer from './slices/userManagement.slice';

const store = configureStore({
  reducer: {
    authState: authReducer,
    careConnectState: careConnectReducer,
    appointmentState: appointmentReducer,
    appointmentSettingsState: appointmentSettingsReducer,
    carePlanState: carePlanReducer,
    encounterState: encounterReducer,
    practitionerState: practitionerReducer,
    summaryState: summaryReducer,
    template: templateReducer,
    settingsState: settingsReducer,
    onboardingState: onboardingReducer,
    paymentsState: paymentsReducer,
    ehrState: ehrReducer,
    specialtyState: specialtyReducer,
    conditionState: conditionReducer,
    doctorsState: doctorsReducer,
    organizationState: organizationReducer,
    promptsState: promptReducer,
    promptOverrideState: promptsReducer,
    templatesState: templatesReducer,
    formConditionsState: formConditionsReducer,
    preBuiltTemplatesState: preBuiltTemplatesReducer,
    humanScribeState: humanScribeReducer,
    templateOverridesState: templateOverridesReducer,
    audioState: audioReducer,
    autotemplateState: autotemplateReducer,
    memoryState: memoryReducer,
    ehrCredentialsState: ehrCredentialsReducer,
    orgSettingState: orgSettingReducer,
    questionnaireState: questionnaireReducer,
    quotaState: quotaReducer,
    knowledgebaseState: knowledgebaseReducer,
    legalConfirmationState: legalConfirmationReducer,
    agentsState: agentsReducer,
    userManagementState: userManagementReducer,
    serviceRequestState: serviceRequestReducer,
  },
});

export * from './actions';
export * from './slices';

export default store;
